interface AboutSectionProps {
  onWhatsAppClick: () => void;
}

export default function AboutSection({ onWhatsAppClick }: AboutSectionProps) {
  return (
    <section id="sobre" className="py-16 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Sobre DJ Jean</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-purple-600 mx-auto mb-6"></div>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            Profissional experiente em som e iluminação para eventos de todos os tipos
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-2xl shadow-lg">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center mr-3">
                  <i className="ri-user-star-line text-white text-lg"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800">Experiência Profissional</h3>
              </div>
              <p className="text-gray-600 leading-relaxed text-sm">
                Com anos de experiência no mercado de eventos, DJ Jean se especializou em criar atmosferas únicas através da combinação perfeita entre som de alta qualidade e iluminação profissional. Cada evento é planejado nos mínimos detalhes.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-2xl shadow-lg">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-gradient-to-r from-green-500 to-blue-500 rounded-full flex items-center justify-center mr-3">
                  <i className="ri-settings-3-line text-white text-lg"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800">Equipamentos de Última Geração</h3>
              </div>
              <p className="text-gray-600 leading-relaxed text-sm">
                Utilizamos apenas equipamentos de primeira linha: mesas de som digitais, caixas de som profissionais, iluminação LED com controle DMX, efeitos especiais, microfones sem fio e toda a infraestrutura necessária.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-2xl shadow-lg">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mr-3">
                  <i className="ri-heart-3-line text-white text-lg"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800">Atendimento Personalizado</h3>
              </div>
              <p className="text-gray-600 leading-relaxed text-sm">
                Cada evento é único! Por isso, oferecemos um atendimento personalizado desde o primeiro contato. Escutamos suas necessidades e garantimos que sua festa seja exatamente como você sonhou.
              </p>
            </div>
          </div>
          
          <div className="space-y-6">
            <div className="bg-gradient-to-br from-blue-600 to-purple-600 text-white p-6 rounded-2xl shadow-xl">
              <h3 className="text-2xl font-bold mb-4 text-center">Por que escolher DJ Jean?</h3>
              <ul className="space-y-3">
                <li className="flex items-center">
                  <i className="ri-check-double-line text-green-300 text-lg mr-3"></i>
                  <span className="text-sm">Mais de 10 anos de experiência</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-double-line text-green-300 text-lg mr-3"></i>
                  <span className="text-sm">Equipamentos profissionais de alta qualidade</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-double-line text-green-300 text-lg mr-3"></i>
                  <span className="text-sm">Repertório atualizado para todos os gostos</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-double-line text-green-300 text-lg mr-3"></i>
                  <span className="text-sm">Pontualidade e profissionalismo garantidos</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-double-line text-green-300 text-lg mr-3"></i>
                  <span className="text-sm">Preços justos e competitivos</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-double-line text-green-300 text-lg mr-3"></i>
                  <span className="text-sm">Backup de equipamentos incluído</span>
                </li>
              </ul>
              <div className="mt-6 pt-4 border-t border-white/20">
                <p className="text-base mb-3">
                  🎵 <strong>Especialidades:</strong> Casamentos românticos, festas animadas, eventos corporativos elegantes
                </p>
                <p className="text-base">
                  🎯 <strong>Missão:</strong> Transformar seu evento em uma experiência inesquecível
                </p>
              </div>
            </div>
            
            <div className="text-center">
              <button 
                onClick={onWhatsAppClick}
                className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-6 py-3 rounded-full text-base font-bold transition-all transform hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap flex items-center mx-auto"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                Falar com DJ Jean
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}